import axios from "axios";
import BASE_URL from "./baseUrl";

export const LOCAL_STORAGE_LOGIN_TOKEN_KEY = "ewa-login-token";
export const X_CSRF_TOKEN = "X-CSRF-TOKEN";
export const XSRF_TOKEN = "XSRF-TOKEN";

axios.defaults.baseURL = BASE_URL;
axios.defaults.withCredentials = true;
